var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
     'text-align': 'center',
     width: _vm.size.w,
     height: _vm.size.h,
     'flex-grow' : 1})},[_c('div',{class:( _obj = {'progress-spinner': true}, _obj['spinner-'+_vm.spinner] = true, _obj )})])}
var staticRenderFns = []

export { render, staticRenderFns }